export const TILE_EDITOR_TAB_CONTENT = 'content';
export const TILE_EDITOR_TAB_ACTION = 'action';
export const TILE_EDITOR_TAB_MOBILE = 'mobile';
export const TILE_EDITOR_TAB_STYLING = 'styling';

export const VALID_TILE_EDITOR_TABS = [
  TILE_EDITOR_TAB_CONTENT,
  TILE_EDITOR_TAB_ACTION,
  TILE_EDITOR_TAB_MOBILE,
  TILE_EDITOR_TAB_STYLING,
];


export const SECTION_EDITOR_TAB_CONTENT = 'content';
export const SECTION_EDITOR_TAB_STYLING = 'styling';
export const SECTION_EDITOR_TAB_MOBILE = 'mobile';
export const SECTION_EDITOR_TAB_ACTION = 'action';

export const VALID_SECTION_EDITOR_TABS = [
  TILE_EDITOR_TAB_CONTENT,
  TILE_EDITOR_TAB_ACTION,
  TILE_EDITOR_TAB_MOBILE,
  TILE_EDITOR_TAB_STYLING,
];
